import { EntityState, EntityStore, EntityActions, QueryEntity, getEntityType, getIDType } from '@datorama/akita';
import { OnDestroy } from '@angular/core';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { getComponentOnDestroy$ } from 'projects/core/src/public-api';

export interface Entity {
    id: number | string;
}

export class AbstractEntityStore<
    S extends EntityState = any,
    EntityType extends Entity = getEntityType<S>,
    IDType = getIDType<S>
> extends EntityStore<S, EntityType, IDType> implements OnDestroy {

    protected syncToQueryUpdates<QS extends EntityState = any>(query: QueryEntity<QS, EntityType, IDType>): Subscription {
        return this.selectQueryUpdate(query)
            .pipe(
                takeUntil(getComponentOnDestroy$(this))
            )
            .subscribe(updatedEntities => {
                this.upsertMany(updatedEntities)
            })
    }

    protected selectQueryUpdate<QS extends EntityState = any>(query: QueryEntity<QS, EntityType, IDType>): Observable<EntityType[]> {
        return this.selectQueryAction(query, EntityActions.Update)
    }

    protected selectQueryAction<QS extends EntityState  = any>(query: QueryEntity<QS, EntityType, IDType>, action: EntityActions): Observable<EntityType[]> {
        return query
            .selectEntityAction(action)
            .pipe(
                map(ids => {
                    return ids.filter(id => this._value().ids.includes(id))
                }),
                filter(ids => ids.length > 0),
                map(ids => {
                    return query.getAll({
                        filterBy: entity => ids.includes(entity.id as any)
                    })
                })
            )
    }
}